// @ts-nocheck
import { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { InputNumber } from 'primereact/inputnumber';
import { Divider } from 'primereact/divider';
import { Slider } from 'primereact/slider';
import { ColorPicker } from 'primereact/colorpicker';
import { Toast } from 'primereact/toast';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"

export const TerrainDrawSettingComponents = (props) => {
    const [fillModeList,] = useState([
        { value: 0, label: "預設" },
        { value: 1, label: "框架" },
        { value: 2, label: "框線" },
        { value: 3, label: "坡度填色" },
        { value: 4, label: "坡向填色" },
        { value: 5, label: "高度填色" }
    ]);
    const [selectFillMode, setSelectFillMode] = useState(0);
    const [throughSurface, setThroughSurface] = useState(false);
    const [waterRipple, setWaterRipple] = useState(false);
    const [waterLevel,] = useState([
        { value: 0, label: "低" },
        { value: 1, label: "普通" },
        { value: 2, label: "高" },
        { value: 3, label: "極高" },
    ]);
    const [selectWaterLevel, setSelectWaterLevel] = useState(1);
    const [seaRipple, setSeaRipple] = useState(true);
    const [seaLevel,] = useState([
        { value: 0, label: "低" },
        { value: 1, label: "普通" },
        { value: 2, label: "高" },
        { value: 3, label: "極高" },
    ]);
    const [selectSeaLevel, setSelectSeaLevel] = useState(1);
    const [seaAltitude, setSeaAltitude] = useState(1);
    const [contourLine, setContourLine] = useState(false);
    const [color, setColor] = useState("F17013");
    const [interval, setInterval] = useState(100);
    const toast = useRef(null);
    useEffect(() => {
        if (window.main.OView === undefined)
            return;
        switch (selectFillMode) {
            case 0:
                window.main.OView.setDrawTerrainSetting({
                    "grid": false,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": true
                });
                break;
            case 1:
                window.main.OView.setDrawTerrainSetting({
                    "grid": false,
                    "vertexWireframe": true,
                    "vertexWireframeWithBaselayer": true,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": false
                });
                break;
            case 2:
                window.main.OView.setDrawTerrainSetting({
                    "grid": true,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": true
                });
                break;
            case 3:
                window.main.OView.setDrawTerrainSetting({
                    "grid": false,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": true },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": true
                });
                break;
            case 4:
                window.main.OView.setDrawTerrainSetting({
                    "grid": false,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": true },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": true
                });
                break;
            case 5:
                window.main.OView.setDrawTerrainSetting({
                    "grid": false,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": true },
                    "wireframeColor": "#ffffff",
                    "surface": true
                });
                break;
            default:
                break;
        };
    }, [selectFillMode])

    useEffect(() => {
        if (window.main.OView === undefined)
            return;
        window.main.OView.throughSurface = throughSurface;
    }, [throughSurface])

    useEffect(() => {
        if (window.main.OView === undefined)
            return;
        if (window.main.OView.getTerrainOverlay('Water') === undefined) {
            return;
        }
        window.main.OView.getTerrainOverlay('Water').show = waterRipple;
        window.main.OView.setDrawTerrainSetting({ showWater: waterRipple });
    }, [waterRipple])

    useEffect(() => {
        if (window.main.OView === undefined)
            return;
        window.main.OView.enableSea = seaRipple;
    }, [seaRipple])

    useEffect(() => {
        if (window.main.OView === undefined)
            return;
        window.main.OView.setDrawTerrainSetting({
            "contourSetting": {
                "isopen": contourLine,
                "color": new window.GLCOLOR(color),
                "interval": interval
            }
        });
    }, [color, interval, contourLine])

    const changeWaterLevel = (value) => {
        switch (value) {
            case 0:
                window.main.OView.setDrawTerrainSetting({ waterQuality: "low" });
                break;
            case 1:
                window.main.OView.setDrawTerrainSetting({ waterQuality: "normal" });
                break;
            case 2:
                window.main.OView.setDrawTerrainSetting({ waterQuality: "high" });
                break;
            case 3:
                window.main.OView.setDrawTerrainSetting({ waterQuality: "very high" });
                break;
            default:
                break;
        }
        setSelectWaterLevel(value)
    }

    const changeSeaLevel = (value) => {
        switch (value) {
            case 0:
                window.main.OView.setSeaQuality("low");
                break;
            case 1:
                window.main.OView.setSeaQuality("normal");
                break;
            case 2:
                window.main.OView.setSeaQuality("high");
                break;
            case 3:
                window.main.OView.setSeaQuality("very high");
                break;
        }
        setSelectSeaLevel(value);
    }

    const changeSeaAltitude = (value) => {
        window.main.OView.setSeaAltitude(parseFloat(value));
        setSeaAltitude(value);
    }

    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="地形地表設定" visible={props.TerrainDrawSetting} modal={false} keepInViewport={false} onHide={() => props.onHide('TerrainDrawSetting')}>
                <Card>
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">繪製模式：</label>
                        <div className="col-12 md:col-8">
                            <Dropdown className="inputfield w-full" value={selectFillMode} options={fillModeList} onChange={(e) => setSelectFillMode(e.value)} optionLabel="label" />
                        </div>
                    </div>
                    <Divider />
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">穿越地表：</label>
                        <div className="col-12 md:col-8">
                            <InputSwitch checked={throughSurface} onChange={(e) => setThroughSurface(e.value)} />
                        </div>
                    </div>
                    <Divider />
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">水面波紋：</label>
                        <div className="col-12 md:col-8">
                            <InputSwitch checked={waterRipple} onChange={(e) => setWaterRipple(e.value)} />
                        </div>
                    </div>
                    {
                        waterRipple ?
                            <Card>
                                <div className="field grid">
                                    <label class="col-12 mb-4 md:col-4 md:mb-0">水面波紋等級：</label>
                                    <div className="col-12 md:col-8">
                                        <Dropdown className="inputfield w-full" value={selectWaterLevel} options={waterLevel} onChange={(e) => changeWaterLevel(e.value)} optionLabel="label" />
                                    </div>
                                </div>
                            </Card> : null
                    }
                    <Divider />
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">海面波紋：</label>
                        <div className="col-12 md:col-8">
                            <InputSwitch checked={seaRipple} onChange={(e) => setSeaRipple(e.value)} />
                        </div>
                    </div>
                    {
                        seaRipple ?
                            <Card>
                                <div className="field grid">
                                    <label class="col-12 mb-4 md:col-4 md:mb-0">海面波紋等級：</label>
                                    <div className="col-12 md:col-8">
                                        <Dropdown className="inputfield w-full" value={selectSeaLevel} options={seaLevel} onChange={(e) => changeSeaLevel(e.value)} optionLabel="label" />
                                    </div>
                                </div>
                                <div className="field grid">
                                    <label class="col-12 mb-4 md:col-4 md:mb-0">高度： {seaAltitude} 公尺</label>
                                    <div className="col-12 md:col-8">
                                        <Slider id="seaAltitude" value={seaAltitude} onChange={(e) => changeSeaAltitude(e.value)} min={-99} max={100} />
                                    </div>
                                </div>
                            </Card> : null
                    }
                    <Divider />
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">等高線：</label>
                        <div className="col-12 md:col-8">
                            <InputSwitch checked={contourLine} onChange={(e) => setContourLine(e.value)} />
                        </div>
                    </div>
                    {
                        contourLine ?
                            <Card>
                                <div className="field grid">
                                    <label class="col-12 mb-4 md:col-4 md:mb-0">等高線顏色：</label>
                                    <div className="col-12 md:col-8">
                                        <ColorPicker value={color} onChange={(e) => setColor(e.value)} ></ColorPicker>
                                    </div>
                                </div>
                                <div className="field grid">
                                    <label class="col-12 mb-4 md:col-4 md:mb-0">等高線間距：</label>
                                    <div className="col-12 md:col-8">
                                        <InputNumber value={interval} onValueChange={(e) => setInterval(e.value)} style={{ width: "100%" }} />
                                    </div>
                                </div>
                            </Card> : null
                    }
                </Card>
            </Dialog>
        </div>
    );
}